"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpecificPlanContext = void 0;
var react_1 = require("react");
var SpecificPlanContext_1 = require("../contexts/SpecificPlanContext");
//This custom hook is responsible for consuming the specific plan context.
function useSpecificPlanContext() {
    var context = (0, react_1.useContext)(SpecificPlanContext_1.SpecificPlanContext);
    if (!context) {
        throw new Error('The useSpecificPlanContext must be used within an SpecificPlanProvider.');
    }
    return context;
}
exports.useSpecificPlanContext = useSpecificPlanContext;
//# sourceMappingURL=useSpecificPlanContext.js.map